"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnSharpRightIcon = PrintableTurnSharpRightIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnSharpRightIcon(_ref) {
  let {
    color,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12 22.92c-1.584 0-3.085-0.345-4.444-0.956v-12.925c0-0.167 0.043-1.631 1.602-1.631 0.663 0 1.638 0.785 2.109 1.294l5.493 5.576h-6.259c-0.31 0-0.563 0.252-0.563 0.563s0.252 0.564 0.563 0.564h7.5c0.311 0 0.563-0.252 0.563-0.563v-7.5c0-0.311-0.252-0.563-0.563-0.563s-0.563 0.252-0.563 0.563v6.022l-5.355-5.438c-0.156-0.168-1.553-1.644-2.925-1.644-2.157 0-2.727 1.802-2.727 2.755v12.337c-3.198-1.906-5.351-5.389-5.351-9.375 0-6.022 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 6.021-4.898 10.919-10.92 10.919z",
    fill: color
  }));
}